(function () {
    'use strict';

    var workbooksService = function ($http) {
        this.searchOrganisations = function (filter) {
            return $http.post('api/thirdparty/workbooks/searchOrganisations', filter)
            .then(function (response) {
                        return response.data;
                    },
                function () {
                    throw ('Workbooks organisations search failure');
                }
            );
        };
    }

    angular.module('app')
        .service('workbooksService', ['$http', workbooksService]);
})();